/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  DocumentDownloadResponse,
  PdfSourceDocument,
} from "../models/index";
import {
  DocumentDownloadResponseFromJSON,
  DocumentDownloadResponseToJSON,
  PdfSourceDocumentFromJSON,
  PdfSourceDocumentToJSON,
} from "../models/index";

export interface DownloadPdfSourceRequest {
  slug: string;
}

/**
 *
 */
export class AttachmentsApi extends runtime.BaseAPI {
  /**
   */
  async downloadPdfSourceRaw(
    requestParameters: DownloadPdfSourceRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<DocumentDownloadResponse>> {
    if (requestParameters["slug"] == null) {
      throw new runtime.RequiredError(
        "slug",
        'Required parameter "slug" was null or undefined when calling downloadPdfSource().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["slug"] != null) {
      queryParameters["slug"] = requestParameters["slug"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/attachments/download-pdf-source`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      DocumentDownloadResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async downloadPdfSource(
    requestParameters: DownloadPdfSourceRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<DocumentDownloadResponse> {
    const response = await this.downloadPdfSourceRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getPdfSourceDocumentsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<PdfSourceDocument>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/attachments/pdf-sources`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(PdfSourceDocumentFromJSON),
    );
  }

  /**
   */
  async getPdfSourceDocuments(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<PdfSourceDocument>> {
    const response = await this.getPdfSourceDocumentsRaw(initOverrides);
    return await response.value();
  }
}
